import { Mutations, Actions, Module, Getters } from 'vuex-smart-module'

import { historyPoints } from '@/store/modules/points/history'
import { PointsService } from '@/api'

export class PointsState {
  points = ''
}

export class PointsGetters extends Getters<PointsState> {}

export class PointsMutations extends Mutations<PointsState> {
  setPoints(points: string) {
    this.state.points = points
  }
}

export class PointsActions extends Actions<PointsState, PointsGetters, PointsMutations> {
  async getPoints() {
    const points = await PointsService.getPoints()
    this.mutations.setPoints(points)
  }
}

export const points = new Module({
  state: PointsState,
  getters: PointsGetters,
  mutations: PointsMutations,
  actions: PointsActions,
  modules: {
    historyPoints,
  },
})
